var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 47,
    viewBox: "0 0 65 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4341 41.3823H48.0886V41.6867C48.0886 44.3388 45.9387 46.4887 43.2866 46.4887H21.2361C18.584 46.4887 16.4341 44.3388 16.4341 41.6867V41.3823Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.2617,
    y: 13.6294,
    width: 2.12605,
    height: 15.3191,
    rx: 1.06303,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.2617,
    y: 13.6294,
    width: 2.12605,
    height: 15.3191,
    rx: 1.06303,
    fill: "#303638"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.398926,
    y: 13.7866,
    width: 2.12605,
    height: 15.3191,
    rx: 1.06303,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.398926,
    y: 13.7866,
    width: 2.12605,
    height: 15.3191,
    rx: 1.06303,
    fill: "#303638"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0576 36.5787C57.5323 36.5787 59.9057 35.643 61.6556 33.9776C63.4055 32.3122 64.3886 30.0533 64.3886 27.698C64.3886 25.3427 63.4055 23.0839 61.6556 21.4185C59.9057 19.753 57.5323 18.8174 55.0576 18.8174L55.0576 27.698V36.5787Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72993 18.8174C7.25519 18.8174 4.88182 19.753 3.13191 21.4185C1.38201 23.0839 0.398926 25.3427 0.398926 27.698C0.398926 30.0533 1.38201 32.3122 3.13191 33.9776C4.88181 35.643 7.25519 36.5787 9.72993 36.5787L9.72993 27.698V18.8174Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03955 26.988C6.03955 14.9511 15.7973 5.19336 27.8341 5.19336H36.4514C48.4882 5.19336 58.2459 14.9511 58.2459 26.9879C58.2459 35.9185 51.0063 43.1581 42.0757 43.1581H22.2097C13.2792 43.1581 6.03955 35.9185 6.03955 26.988Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iii_2912_29013)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.9292,
    y: 19.1802,
    width: 48.4267,
    height: 19.5374,
    rx: 9.76871,
    fill: "url(#paint0_radial_2912_29013)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.144 34.7212C29.6001 34.7212 27.5376 32.8325 27.5376 30.5029H36.7505C36.7505 32.8325 34.688 34.7212 32.144 34.7212Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3953 30.5022C22.9609 30.5022 24.23 29.3094 24.23 27.838C24.23 26.3666 22.9609 25.1738 21.3953 25.1738C19.8297 25.1738 18.5605 26.3666 18.5605 27.838C18.5605 29.3094 19.8297 30.5022 21.3953 30.5022Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8919 30.5022C44.4574 30.5022 45.7266 29.3094 45.7266 27.838C45.7266 26.3666 44.4574 25.1738 42.8919 25.1738C41.3263 25.1738 40.0571 26.3666 40.0571 27.838C40.0571 29.3094 41.3263 30.5022 42.8919 30.5022Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_iii_2912_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8286 5.32629C26.8286 2.80049 28.8762 0.75293 31.402 0.75293H33.1217C35.6475 0.75293 37.6951 2.8005 37.6951 5.3263V8.19663C37.6951 11.1973 35.2626 13.6299 32.2619 13.6299C29.2612 13.6299 26.8286 11.1973 26.8286 8.19663V5.32629Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8286 5.32629C26.8286 2.80049 28.8762 0.75293 31.402 0.75293H33.1217C35.6475 0.75293 37.6951 2.8005 37.6951 5.3263V8.19663C37.6951 11.1973 35.2626 13.6299 32.2619 13.6299C29.2612 13.6299 26.8286 11.1973 26.8286 8.19663V5.32629Z",
    fill: "#303638"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2912_29013",
    x: 16.4341,
    y: 40.4123,
    width: 31.6548,
    height: 6.0765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2912_29013",
    x: 62.2617,
    y: 11.4247,
    width: 3.09604,
    height: 17.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.20468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49918
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.970059,
    dy: -0.705498
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.392157 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_2912_29013",
    x: 0.398926,
    y: 11.5819,
    width: 3.09604,
    height: 17.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.20468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49918
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.970059,
    dy: -0.705498
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.392157 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_2912_29013",
    x: 55.0576,
    y: 17.8473,
    width: 9.33105,
    height: 18.7313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_2912_29013",
    x: 0.398926,
    y: 17.8473,
    width: 9.33105,
    height: 18.7313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_2912_29013",
    x: 6.03955,
    y: 4.2233,
    width: 52.2065,
    height: 38.9349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_2912_29013",
    x: 7.9292,
    y: 19.1802,
    width: 48.4268,
    height: 28.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914673
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.8054
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.6894
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.23206
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.366667 0 0 0 0 0.391667 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37201
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.51535
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.187292 0 0 0 0 0.240573 0 0 0 0 0.258333 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2912_29013",
    result: "effect3_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_2912_29013",
    x: 27.5376,
    y: 29.5329,
    width: 9.21289,
    height: 5.18832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_2912_29013",
    x: 18.5605,
    y: 24.2038,
    width: 5.66943,
    height: 6.29867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_2912_29013",
    x: 40.0571,
    y: 24.2038,
    width: 5.66943,
    height: 6.29867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.970059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0950694 0 0 0 0 0.362841 0 0 0 0 0.616667 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.352749
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.264562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.925941 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_iii_2912_29013",
    x: 26.8286,
    y: 0.75293,
    width: 10.8667,
    height: 16.0783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914673
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.8054
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.20136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.57337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.366667 0 0 0 0 0.391667 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2912_29013",
    result: "effect2_innerShadow_2912_29013"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37201
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.51535
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.366667 0 0 0 0 0.391667 0 0 0 0 0.4 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2912_29013",
    result: "effect3_innerShadow_2912_29013"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2912_29013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0815 22.5285) rotate(22.2376) scale(23.8235 18.4903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobo);
export default __webpack_public_path__ + "static/media/robo.7b34a8e3bdff201bedb029fdcb230abc.svg";
export { ForwardRef as ReactComponent };